
import React from "react";
import { VictoryBar, VictoryChart, VictoryAxis, VictoryTheme, VictoryContainer } from "victory";
import { ChartBarModel } from "../../model/chart/ChartBarModel";

type ChartProps = {
    width: number | string | undefined;
    height: number | undefined;
    showTitle?: boolean;
    data: ChartBarModel;
    colorFunction?: (datum: any) => string;
    textFunction?: (valor: number) => string;
    tickValues?: number[];
};

export default function ChartBar(props: ChartProps) {

    return (
        <div >
            {props.showTitle ? <p style={{ fontSize: 18, fontWeight: 500, color: "#777", marginLeft: 20, marginTop: 10, paddingTop: 10 }}>{props.data.title}</p> : null}
            <VictoryChart
                containerComponent={
                    <VictoryContainer
                        style={{
                            touchAction: "inherit"
                        }}
                    />
                }
                theme={VictoryTheme.material}
                domainPadding={40}
                padding={{ top: 10, bottom: 60, left: 50, right: 50 }}
                width={props.width as number}
                height={props.height as number}
            >
                <VictoryAxis
                    tickValues={props.data.bars.map((item, index) => index + 1)}
                    tickFormat={props.data.bars.map((item, index) => item["name" as keyof typeof item])}
                    style={{
                        tickLabels: {
                            angle: -45,
                            textAnchor: "end",
                            padding: 10, 
                            fontSize: 10
                        }
                    }}
                />
                <VictoryAxis
                    dependentAxis
                    tickValues={props.tickValues || undefined}
                    tickFormat={(x) => (`${x}`)}
                />
                <VictoryBar
                    data={props.data.bars}
                    style={{
                        data: {
                            fill: props.colorFunction
                        }
                    }}
                    x={"name"}
                    y={"y"}
                    labels={({ datum }) => {
                        if (props.textFunction) return props.textFunction(datum.y)
                        return `${datum.y}`
                    }
                    }
                />
            </VictoryChart>
        </div>
    );
}